import React, { useState, useEffect } from 'react'
import { AntInput, AntSelect } from "components/AntComponents";
import { Button } from "antd";
import { Formik } from 'formik';
import { filterFormSchema } from "./validations";
import { cityList, worldCities, countryList, currentStatus, dealType, startupSortValues, investorStatus } from 'formFields';

export function StartupFilterForm({ data, onSubmit, onReset, dynamicFields }) {
    const INITIAL_FORM_DATA = {
        country: null,
        city: null,
        ask_amount_gt: null,
        ask_amount_lt: null,
        industry: null,
        stage: null,
        status: null,
        deal_type: null,
        client_segment: null,
        sector: null,
        tags: null,
        sort: null,
        relationship_manager: null,
        active: null,
    }
    const [formData, setFormData] = useState(INITIAL_FORM_DATA);

    useEffect(() => {
        if (data) {
            setFormData(data);
        }
    }, [data]);

    const handleSubmit = async (payload) => {
        onSubmit(payload);
    }

    const handleClear = async () => {
        setFormData(INITIAL_FORM_DATA);
        onReset();
    }

    return (
        <Formik
            initialValues={formData}
            enableReinitialize
            validationSchema={filterFormSchema}
            onSubmit={handleSubmit}
        >
            {({
                values,
                errors,
                touched,
                handleSubmit,
                setFieldValue,
            }) => {
                const cityOptions = values.country === "India" ? cityList : (worldCities[values.country] || []);
                return (
                <form onSubmit={handleSubmit} onReset={handleClear}>
                    <div className="grid grid-cols-6 gap-10 mb-2">
                        <AntSelect
                            value={values.country}
                            dataSource={countryList}
                            setFieldValue={setFieldValue}
                            fieldName="country"
                            errors={errors}
                            touched={touched}
                            options={{
                                showSearch: true
                            }}
                            onChange={() => setFieldValue('city', null)}
                        />
                        <AntSelect
                            value={values.city}
                            dataSource={cityOptions}
                            setFieldValue={setFieldValue}
                            fieldName="city"
                            errors={errors}
                            touched={touched}
                            options={{
                                showSearch: true
                            }}
                        />
                        <AntInput
                            value={values.ask_amount_gt}
                            setFieldValue={setFieldValue}
                            fieldName={"ask_amount_gt"}
                            errors={errors}
                            touched={touched}
                        />
                        <AntInput
                            value={values.ask_amount_lt}
                            setFieldValue={setFieldValue}
                            fieldName={"ask_amount_lt"}
                            errors={errors}
                            touched={touched}
                        />
                        <AntSelect
                            value={values.industry}
                            dataSource={dynamicFields.industry_choices || []}
                            setFieldValue={setFieldValue}
                            fieldName="industry"
                            errors={errors}
                            touched={touched}
                        />
                        <AntSelect
                            value={values.stage}
                            dataSource={currentStatus}
                            setFieldValue={setFieldValue}
                            fieldName="stage"
                            errors={errors}
                            touched={touched}
                        />
                        <AntSelect
                            value={values.deal_type}
                            dataSource={dealType}
                            setFieldValue={setFieldValue}
                            fieldName="deal_type"
                            errors={errors}
                            touched={touched}
                        />
                        <AntSelect
                            value={values.client_segment}
                            dataSource={dynamicFields.client_segment_choices || []}
                            setFieldValue={setFieldValue}
                            fieldName="client_segment"
                            errors={errors}
                            touched={touched}
                        />
                        <AntSelect
                            value={values.sector}
                            dataSource={dynamicFields.sector_choices || []}
                            setFieldValue={setFieldValue}
                            fieldName="sector"
                            options={{
                                showSearch: true
                            }}
                        />
                        <AntSelect
                            value={values.sort}
                            dataSource={startupSortValues}
                            displayExpr={"name"}
                            valueExpr={"value"}
                            setFieldValue={setFieldValue}
                            fieldName="sort"
                            errors={errors}
                            touched={touched}
                        />
                        <AntSelect
                            value={values.relationship_manager}
                            dataSource={dynamicFields.relationship_managers_choices || []}
                            setFieldValue={setFieldValue}
                            fieldName="relationship_manager"
                            errors={errors}
                            touched={touched}
                        />
                        <AntSelect
                            value={values.active}
                            dataSource={investorStatus}
                            setFieldValue={setFieldValue}
                            fieldName="active"
                            errors={errors}
                            touched={touched}
                        />
                        <AntSelect
                            value={values.tags}
                            dataSource={dynamicFields.tag_choices || []}
                            setFieldValue={setFieldValue}
                            fieldName="tags"
                            options={{
                                showSearch: true,
                                mode: 'multiple',
                            }}
                        />
                    </div>
                    <div className="flex gap-10">
                        <Button
                            htmlType="submit"
                            className="flex flex-row-reverse"
                        >
                            Apply
                        </Button>
                        <Button
                            danger
                            htmlType="reset"
                            className="flex flex-row-reverse"
                        >
                            Clear
                        </Button>
                    </div>

                </form>
                );
            }}
        </Formik>
    )
}
